var map = {
	"./level=01.png": 4172,
	"./level=02.png": 9255,
	"./level=03.png": 9262,
	"./level=04.png": 2353,
	"./level=05.png": 9640,
	"./level=06.png": 4131,
	"./level=07.png": 3370,
	"./level=08.png": 9965,
	"./level=09.png": 8836,
	"./level=10.png": 4410,
	"./level=100.png": 9216,
	"./level=11.png": 2163,
	"./level=12.png": 5304,
	"./level=13.png": 5521,
	"./level=14.png": 2430,
	"./level=15.png": 4919,
	"./level=16.png": 2268,
	"./level=17.png": 8181,
	"./level=18.png": 7330,
	"./level=19.png": 2155,
	"./level=20.png": 7899,
	"./level=21.png": 6770,
	"./level=22.png": 6505,
	"./level=23.png": 256,
	"./level=24.png": 2479,
	"./level=25.png": 3462,
	"./level=26.png": 4669,
	"./level=27.png": 7988,
	"./level=28.png": 3283,
	"./level=29.png": 8074,
	"./level=30.png": 3648,
	"./level=31.png": 7849,
	"./level=32.png": 9666,
	"./level=33.png": 1211,
	"./level=34.png": 6404,
	"./level=35.png": 9645,
	"./level=36.png": 7878,
	"./level=37.png": 1679,
	"./level=38.png": 8264,
	"./level=39.png": 6657,
	"./level=40.png": 3505,
	"./level=41.png": 5640,
	"./level=42.png": 915,
	"./level=43.png": 3338,
	"./level=44.png": 9845,
	"./level=45.png": 748,
	"./level=46.png": 807,
	"./level=47.png": 2494,
	"./level=48.png": 1401,
	"./level=49.png": 6576,
	"./level=50.png": 6854,
	"./level=51.png": 4943,
	"./level=52.png": 5028,
	"./level=53.png": 7533,
	"./level=54.png": 5970,
	"./level=55.png": 4971,
	"./level=56.png": 9936,
	"./level=57.png": 1113,
	"./level=58.png": 5870,
	"./level=59.png": 3559,
	"./level=60.png": 4583,
	"./level=61.png": 2094,
	"./level=62.png": 7845,
	"./level=63.png": 1932,
	"./level=64.png": 1827,
	"./level=65.png": 4074,
	"./level=66.png": 5185,
	"./level=67.png": 4968,
	"./level=68.png": 4815,
	"./level=69.png": 5497,
	"./level=70.png": 9436,
	"./level=71.png": 5349,
	"./level=72.png": 7518,
	"./level=73.png": 7015,
	"./level=74.png": 4872,
	"./level=75.png": 4734,
	"./level=76.png": 4922,
	"./level=77.png": 6835,
	"./level=78.png": 4564,
	"./level=79.png": 5693,
	"./level=80.png": 9309,
	"./level=81.png": 6068,
	"./level=82.png": 1343,
	"./level=83.png": 7542,
	"./level=84.png": 7513,
	"./level=85.png": 3312,
	"./level=86.png": 875,
	"./level=87.png": 9330,
	"./level=88.png": 8485,
	"./level=89.png": 6860,
	"./level=90.png": 6834,
	"./level=91.png": 491,
	"./level=92.png": 8736,
	"./level=93.png": 841,
	"./level=94.png": 5862,
	"./level=95.png": 959,
	"./level=96.png": 8500,
	"./level=97.png": 9629,
	"./level=98.png": 3034,
	"./level=99.png": 3795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8582;